import {
  clearPreservedParam,
  usePreserveQueryParams,
} from "../../../lib/hooks/usePreserveQueryParams";

const IMPERSONATE_STORAGE_KEY = "impersonate";

/**
 * Preserves the ?impersonate= URL param across client-side navigations.
 * Thin wrapper around the generic usePreserveQueryParams hook.
 */
export function usePreserveImpersonateParam(): void {
  usePreserveQueryParams([
    { name: "impersonate", storageKey: IMPERSONATE_STORAGE_KEY },
  ]);
}

/**
 * Clear the impersonate param from sessionStorage.
 * Call when stopping impersonation.
 */
export function clearImpersonateParam(): void {
  clearPreservedParam(IMPERSONATE_STORAGE_KEY);
}
